import React, { useEffect, useState, Component } from 'react';
import { Users, User, BookOpen, BarChart2, Calendar, Bell, Plus, X, ArrowUpRight, ArrowDownRight, Edit2, Trash2, BookIcon, ChevronDown } from 'lucide-react';
import AuroraFloatingCard from '../ui/AuroraFloatingCard';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, TooltipProps } from 'recharts';
// LGS Subject Data
const lgsSubjectData = {
  matematik: {
    name: 'Matematik',
    topics: [{
      konu: 'Üslü Sayılar',
      toplamSoru: 4,
      netOrtalama: 2.8
    }, {
      konu: 'Köklü Sayılar',
      toplamSoru: 5,
      netOrtalama: 3.2
    }, {
      konu: 'Çarpanlar ve Katlar',
      toplamSoru: 3,
      netOrtalama: 2.1
    }, {
      konu: 'Olasılık',
      toplamSoru: 2,
      netOrtalama: 1.2
    }, {
      konu: 'Veri Analizi',
      toplamSoru: 2,
      netOrtalama: 1.7
    }, {
      konu: 'Cebirsel İfadeler',
      toplamSoru: 4,
      netOrtalama: 2.5
    }, {
      konu: 'Eşitsizlikler',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Doğrusal Denklemler ve Eğim',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Dönüşüm Geometrisi',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Geometrik Cisimler',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Üçgenler',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Eşlik ve Benzerlik',
      toplamSoru: 0,
      netOrtalama: 0
    }]
  },
  turkce: {
    name: 'Türkçe',
    topics: [{
      konu: 'Fiilimsiler',
      toplamSoru: 1,
      netOrtalama: 0.7
    }, {
      konu: 'Sözcükte Anlam',
      toplamSoru: 4,
      netOrtalama: 3.1
    }, {
      konu: 'Cümlede Anlam',
      toplamSoru: 2,
      netOrtalama: 1.5
    }, {
      konu: 'Parçada Anlam',
      toplamSoru: 7,
      netOrtalama: 5.2
    }, {
      konu: 'Noktalama İşaretleri',
      toplamSoru: 1,
      netOrtalama: 0.8
    }, {
      konu: 'Yazım Kuralları',
      toplamSoru: 1,
      netOrtalama: 0.7
    }, {
      konu: 'Sözel Mantık / Görsel Okuma',
      toplamSoru: 4,
      netOrtalama: 2.9
    }, {
      konu: 'Deyimler ve Atasözleri',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Söz Sanatları',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Cümlenin Öğeleri',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Metin Türleri',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Fiilde Çatı',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Cümle Türleri',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Anlatım Bozukluğu',
      toplamSoru: 0,
      netOrtalama: 0
    }]
  },
  fenBilimleri: {
    name: 'Fen Bilimleri',
    topics: [{
      konu: 'Mevsimler ve İklim',
      toplamSoru: 3,
      netOrtalama: 2.3
    }, {
      konu: 'DNA ve Genetik Kod',
      toplamSoru: 8,
      netOrtalama: 5.7
    }, {
      konu: 'Basınç',
      toplamSoru: 5,
      netOrtalama: 3.5
    }, {
      konu: 'Madde ve Endüstri',
      toplamSoru: 4,
      netOrtalama: 3.2
    }, {
      konu: 'Basit Makineler',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Enerji Dönüşümleri ve Çevre Bilimi',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Elektrik Yükleri ve Elektrik Enerjisi',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Hücre Bölünmesi ve Kalıtım',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Işığın Kırılması',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Ses',
      toplamSoru: 0,
      netOrtalama: 0
    }]
  },
  sosyalBilgiler: {
    name: 'T.C. İnkılap Tarihi ve Atatürkçülük',
    topics: [{
      konu: 'Bir Kahraman Doğuyor',
      toplamSoru: 5,
      netOrtalama: 3.8
    }, {
      konu: 'Milli Uyanış',
      toplamSoru: 2,
      netOrtalama: 1.5
    }, {
      konu: 'Milli Bir Destan',
      toplamSoru: 3,
      netOrtalama: 2.2
    }, {
      konu: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Demokratikleşme Çabaları',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Atatürk Dönemi Dış Politika',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: "Atatürk'ün Ölümü ve Sonrası",
      toplamSoru: 0,
      netOrtalama: 0
    }]
  },
  ingilizce: {
    name: 'İngilizce',
    topics: [{
      konu: 'Friendship',
      toplamSoru: 4,
      netOrtalama: 3.1
    }, {
      konu: 'In The Kitchen',
      toplamSoru: 2,
      netOrtalama: 1.4
    }, {
      konu: 'On The Phone',
      toplamSoru: 2,
      netOrtalama: 1.5
    }, {
      konu: 'The Internet',
      toplamSoru: 2,
      netOrtalama: 1.6
    }, {
      konu: 'Teen Life',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Adventures',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Tourism',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Chores',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Science',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Natural Forces',
      toplamSoru: 0,
      netOrtalama: 0
    }]
  },
  dinKulturu: {
    name: 'Din Kültürü ve Ahlak Bilgisi',
    topics: [{
      konu: 'Kader İnancı',
      toplamSoru: 4,
      netOrtalama: 3.2
    }, {
      konu: 'Zekat ve Sadaka',
      toplamSoru: 3,
      netOrtalama: 2.3
    }, {
      konu: 'Din ve Hayat',
      toplamSoru: 3,
      netOrtalama: 2.5
    }, {
      konu: 'Bir Peygamber Tanıyorum: Hz. Musa',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: "Hz. Muhammed'in Örnekliği",
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: "Kur'an-ı Kerim ve Özellikleri",
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: "İslam'ın Paylaşmaya ve Yardımlaşmaya Verdiği Önem",
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'İslam Dinine Göre Kötü Davranışlar',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      toplamSoru: 0,
      netOrtalama: 0
    }, {
      konu: 'Hac İbadeti',
      toplamSoru: 0,
      netOrtalama: 0
    }]
  }
};
// Stats data for the KPI cards
const stats = [{
  name: 'Toplam Öğrenci',
  value: '350',
  change: '+5.3%',
  increasing: true,
  icon: Users,
  color: 'blue'
}, {
  name: 'Toplam Öğretmen',
  value: '8',
  change: '+2.2%',
  increasing: true,
  icon: User,
  color: 'purple'
}, {
  name: 'Toplam Sınıf',
  value: '14',
  change: '0%',
  increasing: null,
  icon: BookOpen,
  color: 'pink'
}, {
  name: 'Kurum Net Ortalaması',
  value: '68.5',
  suffix: 'Net',
  change: '-1.4%',
  increasing: false,
  icon: BarChart2,
  color: 'indigo'
}];
// Sample teachers list
const teachersList = [{
  id: 1,
  name: 'Ayşe Yılmaz',
  subject: 'Matematik'
}, {
  id: 2,
  name: 'Mehmet Demir',
  subject: 'Fen Bilgisi'
}, {
  id: 3,
  name: 'Zeynep Kaya',
  subject: 'Türkçe'
}, {
  id: 4,
  name: 'Ahmet Şahin',
  subject: 'İngilizce'
}, {
  id: 5,
  name: 'Fatma Çelik',
  subject: 'Sosyal Bilgiler'
}];
// Reminder Modal Component
const YeniHatirlaticiModal = ({
  onClose,
  onSave,
  editingReminder = null
}) => {
  const [text, setText] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [dueTime, setDueTime] = useState('');
  const [assignee, setAssignee] = useState('kendim');
  // If editing, populate the form with existing data
  useEffect(() => {
    if (editingReminder) {
      setText(editingReminder.text);
      if (editingReminder.dueDateTime) {
        const dateTime = new Date(editingReminder.dueDateTime);
        setDueDate(dateTime.toISOString().split('T')[0]);
        setDueTime(dateTime.toTimeString().slice(0, 5));
      }
      setAssignee(editingReminder.assignee || 'kendim');
    }
  }, [editingReminder]);
  const handleSubmit = e => {
    e.preventDefault();
    let dueDateTime = null;
    if (dueDate && dueTime) {
      dueDateTime = new Date(`${dueDate}T${dueTime}:00`);
    }
    onSave({
      id: editingReminder?.id,
      text,
      dueDateTime,
      assignee,
      assigneeName: assignee === 'kendim' ? null : teachersList.find(t => t.id.toString() === assignee)?.name
    });
    onClose();
  };
  return <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50" data-id="element-44">
      <AuroraFloatingCard className="w-full max-w-lg" data-id="element-45">
        <div className="relative" data-id="element-46">
          <h3 className="text-lg font-bold mb-4" data-id="element-47">
            {editingReminder ? 'Hatırlatıcı Düzenle' : 'Yeni Hatırlatıcı Ekle'}
          </h3>
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-48">
            <div data-id="element-49">
              <label className="block text-sm font-medium mb-1" data-id="element-50">
                Hatırlatıcı Metni
              </label>
              <textarea value={text} onChange={e => setText(e.target.value)} className="w-full h-24 bg-[#1C2333] text-white rounded-lg p-3 border border-purple-500/30 focus:border-blue-500 focus:ring-blue-500/50" placeholder="Hatırlatıcı metnini girin..." required data-id="element-51" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-52">
              <div data-id="element-53">
                <label className="block text-sm font-medium mb-1" data-id="element-54">
                  Son Tarih
                </label>
                <input type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} className="w-full bg-[#1C2333] text-white rounded-lg p-2 border border-purple-500/30 focus:border-blue-500 focus:ring-blue-500/50" data-id="element-55" />
              </div>
              <div data-id="element-56">
                <label className="block text-sm font-medium mb-1" data-id="element-57">
                  Son Saat
                </label>
                <input type="time" value={dueTime} onChange={e => setDueTime(e.target.value)} className="w-full bg-[#1C2333] text-white rounded-lg p-2 border border-purple-500/30 focus:border-blue-500 focus:ring-blue-500/50" data-id="element-58" />
              </div>
            </div>
            <div data-id="element-59">
              <label className="block text-sm font-medium mb-1" data-id="element-60">Kime Ata</label>
              <select value={assignee} onChange={e => setAssignee(e.target.value)} className="w-full bg-[#1C2333] text-white rounded-lg p-2 border border-purple-500/30 focus:border-blue-500 focus:ring-blue-500/50" data-id="element-61">
                <option value="kendim" data-id="element-62">Kendim İçin</option>
                <optgroup label="Öğretmenler" data-id="element-63">
                  {teachersList.map(teacher => <option key={teacher.id} value={teacher.id.toString()} data-id="element-64">
                      {teacher.name} ({teacher.subject})
                    </option>)}
                </optgroup>
              </select>
            </div>
            <div className="flex justify-end gap-3 mt-4" data-id="element-65">
              <button type="button" onClick={onClose} className="px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10" data-id="element-66">
                İptal
              </button>
              <button type="submit" className="px-4 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-purple-600 hover:opacity-90" data-id="element-67">
                {editingReminder ? 'Güncelle' : 'Kaydet'}
              </button>
            </div>
          </form>
          <button onClick={onClose} className="absolute top-0 right-0 text-gray-500 hover:text-white" data-id="element-68">
            <X className="w-5 h-5" data-id="element-69" />
          </button>
        </div>
      </AuroraFloatingCard>
    </div>;
};
// Event Modal Component
const YeniEtkinlikModal = ({
  onClose,
  onSave,
  editingEvent = null
}) => {
  const [date, setDate] = useState('');
  const [title, setTitle] = useState('');
  const [location, setLocation] = useState('');
  // If editing, populate the form with existing data
  useEffect(() => {
    if (editingEvent) {
      setTitle(editingEvent.title);
      setLocation(editingEvent.location);
      // Convert date string to ISO format if possible
      if (editingEvent.date) {
        const parts = editingEvent.date.split(' ');
        if (parts.length >= 3) {
          const day = parts[0];
          const month = getMonthNumber(parts[1]);
          const year = parts[2];
          if (day && month && year) {
            const isoDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
            setDate(isoDate);
          }
        }
      }
    }
  }, [editingEvent]);
  // Helper to convert Turkish month names to numbers
  const getMonthNumber = monthName => {
    const months = {
      Ocak: 1,
      Şubat: 2,
      Mart: 3,
      Nisan: 4,
      Mayıs: 5,
      Haziran: 6,
      Temmuz: 7,
      Ağustos: 8,
      Eylül: 9,
      Ekim: 10,
      Kasım: 11,
      Aralık: 12
    };
    return months[monthName];
  };
  // Helper to convert numbers to Turkish month names
  const getMonthName = monthNumber => {
    const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    return months[monthNumber - 1];
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Convert ISO date to Turkish format
    let formattedDate = '';
    if (date) {
      const [year, month, day] = date.split('-');
      formattedDate = `${parseInt(day)} ${getMonthName(parseInt(month))} ${year}`;
    }
    onSave({
      id: editingEvent?.id,
      title,
      date: formattedDate,
      location
    });
    onClose();
  };
  return <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50" data-id="element-70">
      <AuroraFloatingCard className="w-full max-w-lg" data-id="element-71">
        <div className="relative" data-id="element-72">
          <h3 className="text-lg font-bold mb-4" data-id="element-73">
            {editingEvent ? 'Etkinlik Düzenle' : 'Yeni Etkinlik Ekle'}
          </h3>
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-74">
            <div data-id="element-75">
              <label className="block text-sm font-medium mb-1" data-id="element-76">Tarih</label>
              <input type="date" value={date} onChange={e => setDate(e.target.value)} className="w-full bg-[#1C2333] text-white rounded-lg p-2 border border-purple-500/30 focus:border-purple-500 focus:ring-purple-500/50" required data-id="element-77" />
            </div>
            <div data-id="element-78">
              <label className="block text-sm font-medium mb-1" data-id="element-79">
                Etkinlik Başlığı
              </label>
              <input type="text" value={title} onChange={e => setTitle(e.target.value)} className="w-full bg-[#1C2333] text-white rounded-lg p-2 border border-purple-500/30 focus:border-purple-500 focus:ring-purple-500/50" required data-id="element-80" />
            </div>
            <div data-id="element-81">
              <label className="block text-sm font-medium mb-1" data-id="element-82">
                Etkinlik Yeri/Notu
              </label>
              <input type="text" value={location} onChange={e => setLocation(e.target.value)} className="w-full bg-[#1C2333] text-white rounded-lg p-2 border border-purple-500/30 focus:border-purple-500 focus:ring-purple-500/50" required data-id="element-83" />
            </div>
            <div className="flex justify-end gap-3 mt-4" data-id="element-84">
              <button type="button" onClick={onClose} className="px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10" data-id="element-85">
                İptal
              </button>
              <button type="submit" className="px-4 py-2 rounded-lg bg-gradient-to-r from-purple-600 to-blue-600 hover:opacity-90" data-id="element-86">
                {editingEvent ? 'Güncelle' : 'Kaydet'}
              </button>
            </div>
          </form>
          <button onClick={onClose} className="absolute top-0 right-0 text-gray-500 hover:text-white" data-id="element-87">
            <X className="w-5 h-5" data-id="element-88" />
          </button>
        </div>
      </AuroraFloatingCard>
    </div>;
};
// Confirmation Dialog Component
const ConfirmDialog = ({
  message,
  onConfirm,
  onCancel
}) => {
  return <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50" data-id="element-89">
      <AuroraFloatingCard className="w-full max-w-md" data-id="element-90">
        <div className="p-4" data-id="element-91">
          <h3 className="text-lg font-bold mb-4" data-id="element-92">Onay</h3>
          <p className="mb-6" data-id="element-93">{message}</p>
          <div className="flex justify-end gap-3" data-id="element-94">
            <button onClick={onCancel} className="px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10" data-id="element-95">
              İptal
            </button>
            <button onClick={onConfirm} className="px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700" data-id="element-96">
              Sil
            </button>
          </div>
        </div>
      </AuroraFloatingCard>
    </div>;
};
// LGS Subject Analysis Component with Horizontal Progress Bars
const LGSSubjectAnalysis = ({
  subject
}) => {
  const data = lgsSubjectData[subject] || {
    topics: []
  };
  return <div className="h-full overflow-y-auto pr-2 custom-scrollbar" data-id="element-97">
      <div className="space-y-3" data-id="element-98">
        {data.topics.map((topic, index) => <div key={index} className="flex items-center justify-between gap-3 p-3 rounded-lg bg-gray-800/30 border border-gray-700/50 hover:bg-gray-800/50 hover:border-purple-500/30 transition-all" data-id="element-99">
            {/* Konu Adı */}
            <div className="w-1/3 min-w-0 pr-2" data-id="element-100">
              <p className="text-sm font-medium text-white truncate" title={topic.konu} data-id="element-101">
                {topic.konu}
              </p>
            </div>
            {/* Progress Bar veya Soru Çıkmadı Mesajı */}
            {topic.toplamSoru > 0 ? <>
                {/* Progress Bar */}
                <div className="flex-1 min-w-[120px]" data-id="element-102">
                  <div className="h-7 bg-gray-900/80 rounded-md overflow-hidden border border-purple-500/30" data-id="element-103">
                    <div className="h-full bg-gradient-to-r from-blue-600 to-purple-600 rounded-md transition-all duration-500 ease-out flex items-center justify-end pr-2" style={{
                width: `${Math.max(topic.netOrtalama / topic.toplamSoru * 100, 10)}%`
              }} data-id="element-104">
                      {topic.netOrtalama / topic.toplamSoru * 100 >= 30 && <span className="text-xs text-white font-medium" data-id="element-105">
                          {topic.netOrtalama.toFixed(1)}
                        </span>}
                    </div>
                  </div>
                </div>
                {/* Net / Toplam */}
                <div className="w-20 text-right flex-shrink-0" data-id="element-106">
                  <p className="text-sm font-semibold text-white" data-id="element-107">
                    {topic.netOrtalama.toFixed(1)} / {topic.toplamSoru}
                  </p>
                </div>
              </> : <div className="flex-1 text-right" data-id="element-108">
                <p className="text-sm text-gray-500 italic" data-id="element-109">Soru çıkmadı</p>
              </div>}
          </div>)}
      </div>
    </div>;
};
export function YoneticiDashboard() {
  // State for reminders
  const [reminders, setReminders] = useState([{
    id: 1,
    text: '8-A sınıfı veli toplantısı raporunu onayla.',
    dueDateTime: new Date('2023-10-25T15:00:00'),
    assignee: 'kendim'
  }, {
    id: 2,
    text: 'Yeni LGS-7 deneme sınavı sorularını sisteme yükle.',
    dueDateTime: new Date('2023-10-26T09:00:00'),
    assignee: 'kendim'
  }, {
    id: 3,
    text: 'Matematik zümresi için aylık toplantı planla.',
    dueDateTime: new Date('2023-10-27T14:30:00'),
    assignee: '1',
    assigneeName: 'Ayşe Yılmaz'
  }]);
  // State for events
  const [events, setEvents] = useState([{
    id: 1,
    title: 'Genel Veli Toplantısı',
    date: '25 Ekim 2023',
    location: 'Konferans Salonu'
  }, {
    id: 2,
    title: '8. Sınıflar Motivasyon Semineri',
    date: '28 Ekim 2023',
    location: 'Online'
  }]);
  // State for modals and editing
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [showEventModal, setShowEventModal] = useState(false);
  const [editingReminder, setEditingReminder] = useState(null);
  const [editingEvent, setEditingEvent] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState('matematik');
  const [showSubjectDropdown, setShowSubjectDropdown] = useState(false);
  // Format date for display
  const formatDateTime = date => {
    if (!date) return 'Belirtilmemiş';
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const isToday = date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
    const isTomorrow = date.getDate() === tomorrow.getDate() && date.getMonth() === tomorrow.getMonth() && date.getFullYear() === tomorrow.getFullYear();
    // Format time
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const timeStr = `${hours}:${minutes}`;
    if (isToday) {
      return `Bugün ${timeStr}`;
    } else if (isTomorrow) {
      return `Yarın ${timeStr}`;
    } else {
      return date.toLocaleDateString('tr-TR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }) + ` ${timeStr}`;
    }
  };
  // Handle saving a reminder
  const handleSaveReminder = reminderData => {
    if (reminderData.id) {
      // Update existing reminder
      setReminders(reminders.map(r => r.id === reminderData.id ? {
        ...reminderData
      } : r));
    } else {
      // Add new reminder
      const newReminder = {
        ...reminderData,
        id: reminders.length > 0 ? Math.max(...reminders.map(r => r.id)) + 1 : 1
      };
      setReminders([...reminders, newReminder]);
    }
    setEditingReminder(null);
  };
  // Handle editing a reminder
  const handleEditReminder = reminder => {
    setEditingReminder(reminder);
    setShowReminderModal(true);
  };
  // Handle deleting a reminder
  const handleDeleteReminder = reminder => {
    setItemToDelete({
      type: 'reminder',
      item: reminder
    });
    setShowDeleteConfirm(true);
  };
  // Handle saving an event
  const handleSaveEvent = eventData => {
    if (eventData.id) {
      // Update existing event
      setEvents(events.map(e => e.id === eventData.id ? {
        ...eventData
      } : e));
    } else {
      // Add new event
      const newEvent = {
        ...eventData,
        id: events.length > 0 ? Math.max(...events.map(e => e.id)) + 1 : 1
      };
      setEvents([...events, newEvent]);
    }
    setEditingEvent(null);
  };
  // Handle editing an event
  const handleEditEvent = event => {
    setEditingEvent(event);
    setShowEventModal(true);
  };
  // Handle deleting an event
  const handleDeleteEvent = event => {
    setItemToDelete({
      type: 'event',
      item: event
    });
    setShowDeleteConfirm(true);
  };
  // Handle confirmation of deletion
  const handleConfirmDelete = () => {
    if (itemToDelete.type === 'reminder') {
      setReminders(reminders.filter(r => r.id !== itemToDelete.item.id));
    } else if (itemToDelete.type === 'event') {
      setEvents(events.filter(e => e.id !== itemToDelete.item.id));
    }
    setShowDeleteConfirm(false);
    setItemToDelete(null);
  };
  // Sort events by date
  const sortedEvents = [...events].sort((a, b) => {
    // Parse Turkish date format "25 Ekim 2023"
    const parseDate = dateStr => {
      const parts = dateStr.split(' ');
      const day = parseInt(parts[0]);
      const monthMap = {
        Ocak: 0,
        Şubat: 1,
        Mart: 2,
        Nisan: 3,
        Mayıs: 4,
        Haziran: 5,
        Temmuz: 6,
        Ağustos: 7,
        Eylül: 8,
        Ekim: 9,
        Kasım: 10,
        Aralık: 11
      };
      const month = monthMap[parts[1]];
      const year = parseInt(parts[2]);
      return new Date(year, month, day);
    };
    return parseDate(a.date) - parseDate(b.date);
  });
  // Clean up expired reminders
  useEffect(() => {
    const now = new Date();
    setReminders(prev => prev.filter(r => !r.dueDateTime || r.dueDateTime > now));
    // Set up interval to check every minute
    const interval = setInterval(() => {
      setReminders(prev => prev.filter(r => !r.dueDateTime || r.dueDateTime > new Date()));
    }, 60000);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex flex-col gap-6 pb-8" data-id="element-110">
      {/* Modals */}
      {showReminderModal && <YeniHatirlaticiModal onClose={() => {
      setShowReminderModal(false);
      setEditingReminder(null);
    }} onSave={handleSaveReminder} editingReminder={editingReminder} data-id="element-111" />}
      {showEventModal && <YeniEtkinlikModal onClose={() => {
      setShowEventModal(false);
      setEditingEvent(null);
    }} onSave={handleSaveEvent} editingEvent={editingEvent} data-id="element-112" />}
      {showDeleteConfirm && <ConfirmDialog message={`Bu ${itemToDelete.type === 'reminder' ? 'hatırlatıcıyı' : 'etkinliği'} silmek istediğinizden emin misiniz?`} onConfirm={handleConfirmDelete} onCancel={() => {
      setShowDeleteConfirm(false);
      setItemToDelete(null);
    }} data-id="element-113" />}
      {/* 1. İstatistik Kartları - Responsive grid with equal heights */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-114">
        {stats.map((stat, index) => <AuroraFloatingCard key={stat.name} className="h-full flex flex-col justify-between" data-id="element-115">
            <div className="flex items-center space-x-4" data-id="element-116">
              <div className={`bg-${stat.color}-500/10 text-${stat.color}-400 p-2 sm:p-3 rounded-lg`} data-id="element-117">
                <stat.icon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-118" />
              </div>
              <div data-id="element-119">
                <p className="text-xs sm:text-sm text-gray-400 whitespace-nowrap" data-id="element-120">
                  {stat.name}
                </p>
                <div className="flex items-baseline gap-1" data-id="element-121">
                  <p className="text-xl sm:text-2xl font-bold text-white" data-id="element-122">
                    {stat.value}
                  </p>
                  {stat.suffix && <span className="text-xs sm:text-sm text-gray-400 font-normal" data-id="element-123">
                      {stat.suffix}
                    </span>}
                </div>
              </div>
            </div>
            {/* Only show percentage change for cards other than "Toplam Öğretmen" and "Toplam Sınıf" */}
            {stat.change && index !== 1 && index !== 2 && <div className="mt-3 sm:mt-4 flex items-center" data-id="element-124">
                {stat.increasing === true && <ArrowUpRight className="w-3 h-3 sm:w-4 sm:h-4 text-green-500 mr-1" data-id="element-125" />}
                {stat.increasing === false && <ArrowDownRight className="w-3 h-3 sm:w-4 sm:h-4 text-red-500 mr-1" data-id="element-126" />}
                <span className={`text-xs font-medium ${stat.increasing === true ? 'text-green-500' : stat.increasing === false ? 'text-red-500' : 'text-gray-400'}`} data-id="element-127">
                  {stat.change} geçen aya göre
                </span>
              </div>}
            {/* Add empty div for cards without percentage change to maintain equal height */}
            {(!stat.change || index === 1 || index === 2) && <div className="mt-3 sm:mt-4 h-4" data-id="element-128"></div>}
          </AuroraFloatingCard>)}
      </div>
      {/* 2. LGS Konu Bazlı Başarı Analizi (Full width) */}
      <div className="w-full" data-id="element-129">
        <AuroraFloatingCard className="h-[350px] sm:h-[400px]" data-id="element-130">
          <div className="flex flex-col h-full" data-id="element-131">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 sm:mb-6 gap-3" data-id="element-132">
              <h2 className="text-lg sm:text-xl font-bold flex items-center gap-2 sm:gap-3 truncate" data-id="element-133">
                <BookIcon className="w-4 h-4 sm:w-5 sm:h-5 text-blue-400 flex-shrink-0" data-id="element-134" />
                <span className="truncate" data-id="element-135">LGS Konu Bazlı Başarı Analizi</span>
              </h2>
              {/* Subject Selection Dropdown */}
              <div className="relative" data-id="element-136">
                <button onClick={() => setShowSubjectDropdown(!showSubjectDropdown)} className="flex items-center justify-between gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-gray-800/50 border border-purple-500/30 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500 w-full sm:w-auto sm:min-w-[200px]" data-id="element-137">
                  <span className="text-xs sm:text-sm truncate" data-id="element-138">
                    {lgsSubjectData[selectedSubject]?.name || selectedSubject}
                  </span>
                  <ChevronDown size={16} className="flex-shrink-0" data-id="element-139" />
                </button>
                {showSubjectDropdown && <div className="absolute right-0 mt-2 z-10 w-full bg-gray-900 border border-gray-700 rounded-lg shadow-xl py-2" data-id="element-140">
                    {Object.keys(lgsSubjectData).map(subject => <button key={subject} onClick={() => {
                  setSelectedSubject(subject);
                  setShowSubjectDropdown(false);
                }} className="w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-800" data-id="element-141">
                        {lgsSubjectData[subject]?.name || subject}
                      </button>)}
                  </div>}
              </div>
            </div>
            {/* Subject Analysis with Horizontal Progress Bars */}
            <div className="flex-1 overflow-hidden mt-2" data-id="element-142">
              <LGSSubjectAnalysis subject={selectedSubject} data-id="element-143" />
            </div>
          </div>
        </AuroraFloatingCard>
      </div>
    </div>;
}